
export enum CustomerEstimationType {
    Estimated = 1,
    UnderEstimated = 2,
    OverEstimated = 3
}
